import { useState } from "react";
import { Image, Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import Img from '../Img/Contact/Contact-Banner2.jpg';
// import Img from '../Img/Contact/ContactUs Banner.jpg';
import "./Services.css";
import Phone from '../Img/Contact Icons/call.png';
import Mail from '../Img/Contact Icons/mail.png';
import Map from '../Img/Contact Icons/map.png';
import Whatsapp from '../Img/Contact Icons/whatsapp.png';

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    enquiry: "",
    preferred_date: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, message, enquiry } = formData;

    if (!name || !email || !message) {
      alert("Please fill in all required fields.");
      return;
    }

    const subject = enquiry || "New Enquiry";
    const body = `
Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company}
Phone: ${formData.phone}
Preferred Date: ${formData.preferred_date}

Message:
${formData.message}
    `;

    const mailtoLink = `mailto:info@bharatrugagencies.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  return (
    <>
      <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />

      <Container>
        <div>
          <h1 className='text-center my-4 text-decoration-underline'><strong>Contact Us</strong></h1>
          {/* <hr style={{ border: '2px', height: '3px', backgroundColor: 'red' }} /> */}
          <Row>
            <Col xs={12} md={6} className='my-3 py-2'>
              <p className="justify-text" style={{ fontSize: "clamp(1rem, 2vw, 1.5rem)" }}><strong>Whether you’re looking to India as a potential marketplace or a source for goods, we can be your reliable partner.</strong></p>
              <p className="py-3" style={{ textIndent: "-3rem", fontSize: "clamp(1rem, 2vw, 1.5rem)" }}>
                <img className='mx-2' src={Phone} alt="Phone Logo" width={30} height={30} />
                <strong>Mobile-</strong>
                <a href="tel:+919453001175" className="contact-link mx-2">
                   <span style={{ paddingLeft: "1rem" }}>+91-945-300-1175</span> 
                </a></p>
              <p className="py-3" style={{ textIndent: "-3rem", fontSize: "clamp(1rem, 2vw, 1.5rem)" }}>
                <img className='mx-2' src={Whatsapp} alt="Phone Logo" width={30} height={30} />
                <strong>WhatsApp-</strong>
                <a
                  href="https://wa.me/+917460012246?"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chat with us on WhatsApp"
                  className="contact-link mx-2"
                >
                  +91-746-001-2246
                </a>
              </p>

              <p className="py-3" style={{ textIndent: "-3rem", fontSize: "clamp(1rem, 2vw, 1.5rem)" }}>
                <img className='mx-2' src={Mail} alt="Phone Logo" width={30} height={30} />
                <strong>Email-</strong>
                <a href="mailto:info@bharatrugagencies.com" className="contact-link mx-2">
                  <span style={{ paddingLeft: "2rem" }}>info@bharatrugagencies.com</span>
                  
                </a></p>

              <p className="pt-3 justify-text" style={{ textIndent: "-3rem", fontSize: "clamp(1rem, 2vw, 1.5rem)" }}>
                <img className="mx-2" src={Map} alt="Phone Logo" width={30} height={30} />
                <strong>Address-</strong> 19/53, Ramsahaypur Road, 
                <br />
                <span style={{ padding: "7rem" }}> Bhadohi - 221401</span>                
                <br />
                <span style={{ padding: "7rem" }}>Uttar Pradesh</span>
                <br />
                <span style={{ padding: "7rem" }}> India.</span>                
              </p>

            </Col>

            {/* Right Section – Form */}
            <Col xs={12} md={6} className="my-3 py-2">
              <Card style={{ border: "3px solid #9e6b0c" }}>
                <Card.Body>
                  <Card.Title className="text-center"> <strong><u>Send Your Enquiry</u></strong> </Card.Title>
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label> <strong>Name*</strong></Form.Label>
                        <Form.Control
                          placeholder="Enter your name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </Col>

                      <Col md={6}>
                        <Form.Label> <strong>Company</strong></Form.Label>
                        <Form.Control
                          placeholder="Enter your company name"
                          name="company"
                          value={formData.company}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label> <strong>Email*</strong> </Form.Label>
                        <Form.Control
                          placeholder="Enter your email"
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Col>

                      <Col md={6}>
                        <Form.Label> <strong>Phone Number*</strong> </Form.Label>
                        <Form.Control
                          placeholder="Enter your phone number"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label> <strong>Type of Enquiry</strong></Form.Label>
                        <Form.Control
                          placeholder="Type of Enquiry"
                          name="enquiry"
                          value={formData.enquiry}
                          onChange={handleChange}
                        />
                      </Col>

                      <Col md={6}>
                        <Form.Label> <strong>Preferred Date</strong> </Form.Label>
                        <Form.Control
                          type="date"
                          name="preferred_date"
                          value={formData.preferred_date}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label> <strong>Message*</strong> </Form.Label>
                      <Form.Control
                        placeholder="Your message"
                        as="textarea"
                        rows={4}
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Button type="submit" className="w-100">
                      Submit Form
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          
          {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3604.1990524056923!2d82.57163489999999!3d25.3981468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398fde1a1e61a1f1%3A0xf9baf5f56da299b7!2s9HXC%2B6JX%2C%20Bhadohi%20Nagar%20Palika%2C%20Uttar%20Pradesh%20221401!5e0!3m2!1sen!2sin!4v1759130153011!5m2!1sen!2sin"
                    style={{ width: "100%", height: 500 }}
                    title='Map' ></iframe> */}
        </div>
      </Container>
    </>
  )
}

export default Contact